module.exports = __webpack_public_path__ + "static/media/slim-fit-suit.4a69a8e2.jpg";